export default __webpack_public_path__ + "static/media/Scenario5.32314039.mp4";